"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthField = void 0;
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var useStyles_1 = require("../../styles/hooks/useStyles");
var react_2 = require("../../util/react");
var FocusManagerContainer_1 = require("../FocusManagerContainer");
var MonthPicker_1 = require("../MonthPicker");
var util_1 = require("../MonthRangePicker/util");
var util_2 = require("../Calendar/util");
var MonthInput_1 = require("./MonthInput");
function MonthField(props) {
    var value = props.value, popperProps = props.popperProps, inputRef = props.inputRef, onChange = props.onChange, onIconClick = props.onIconClick, maxMonth = props.maxMonth, minMonth = props.minMonth, rest = __rest(props, ["value", "popperProps", "inputRef", "onChange", "onIconClick", "maxMonth", "minMonth"]);
    var _a = useStyles_1.useStyles(createStyles), classes = _a.classes, css = _a.css;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var _c = react_1.useState(), anchorRef = _c[0], setAnchorRef = _c[1];
    var _d = react_1.useState(), popperRef = _d[0], setPopperRef = _d[1];
    var _e = react_1.useState({
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
    }), visibleMonth = _e[0], setVisibleMonth = _e[1];
    react_1.useEffect(function () {
        setVisibleMonth(util_2.isValidReferenceMonth(value)
            ? value
            : {
                month: new Date().getMonth(),
                year: new Date().getFullYear(),
            });
    }, [value]);
    var _f = react_popper_1.usePopper(anchorRef, popperRef, __assign(__assign({}, popperProps), { placement: 'bottom-start' })), popperStyle = _f.styles.popper, placement = _f.attributes.placement;
    var handleVisibleMonthChange = function (month) { return setVisibleMonth(month); };
    var handleInputChange = function (month) {
        onChange(month);
    };
    var handleMonthClick = function (month) {
        setOpen(false);
        onChange(month);
    };
    var handleInputIconClick = function () { return setOpen(true); };
    var handleFocusIn = function () { return setOpen(true); };
    var handleFocusOut = function () { return setOpen(false); };
    return (react_1.default.createElement(FocusManagerContainer_1.FocusManagerContainer, { onFocusIn: handleFocusIn, onFocusOut: handleFocusOut },
        react_1.default.createElement(MonthInput_1.MonthInput, __assign({ inputRef: react_2.composeRefs(setAnchorRef, inputRef), value: value, icon: 'calendarOutline', onIconClick: react_2.composeHandlers(handleInputIconClick, onIconClick), onChange: handleInputChange }, rest)),
        open && (react_1.default.createElement("div", { ref: setPopperRef, className: css(classes.popup, popperStyle), "data-placement": placement, "data-testid": 'MonthField.popup' },
            react_1.default.createElement(MonthPicker_1.MonthPicker, __assign({ visibleMonth: visibleMonth, onVisibleMonthChange: handleVisibleMonthChange, onMonthClick: handleMonthClick, isDisabled: util_1.disabledByMonth(minMonth, maxMonth), modifiers: {
                    selected: function (month) { return value && util_1.isSameReferenceMonth(value, month); },
                } }, props.monthPickerProps))))));
}
exports.MonthField = MonthField;
var createStyles = function (theme) { return ({
    popup: {
        zIndex: theme.zIndex.popper,
    },
}); };
//# sourceMappingURL=MonthField.js.map